import apiClient from './apiClient';

// ============================================================
// Types
// ============================================================

export interface QueryRequest {
  year: number;
  month: number;
  deptLevel: number; // 1=部, 2=課, 3=組
  deptFrom: string;
  deptTo: string;
}

export interface SalaryCategory {
  code: string;
  name: string;
  amount: number;
}

export interface DeptSalarySummary {
  deptCode: string;
  deptName: string;
  empCount: number;
  categories: SalaryCategory[];
  total: number;
}

export interface GrandTotal {
  empCount: number;
  categories: SalaryCategory[];
  total: number;
}

export interface QueryResponse {
  data: DeptSalarySummary[];
  grandTotal: GrandTotal;
}

export interface LookupResult {
  code: string;
  name: string;
}

// ============================================================
// API Client
// ============================================================

export const pw933aApi = {
  async query(req: QueryRequest): Promise<QueryResponse> {
    const res = await apiClient.post('/api/pw933a/query', req);
    return res.data;
  },

  async lookup(type: string, code: string): Promise<LookupResult> {
    const res = await apiClient.get(`/api/pw933a/lookup/${type}/${encodeURIComponent(code)}`);
    return res.data;
  },
};
